import React, { useState, useRef, useEffect } from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
};

export default function FAQItem({ title, children, icon }: Props) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [maxH, setMaxH] = useState<string>('0px');

  useEffect(() => {
    if (open) {
      const height = contentRef.current?.scrollHeight ?? 0;
      // set to scrollHeight to allow smooth expand
      setMaxH(`${height}px`);
    } else {
      // collapse
      setMaxH('0px');
    }
  }, [open]);

  return (
    <article className="relative rounded-[1.3rem] border border-[#dbe8f5] bg-white p-1 shadow-[0_20px_42px_-34px_rgba(13,27,42,0.7)]">
      <div className="flex items-start gap-4 rounded-[1.1rem] bg-gradient-to-r from-[#f7fbff] to-white p-5">
        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#e9f2fb] text-xl text-[#2b6cb0]">
          {icon}
        </div>

        <div className="min-w-0 flex-1">
          <div className="w-full text-left">
            <button
              aria-expanded={open}
              onClick={() => setOpen(v => !v)}
              className="w-full flex items-center justify-between"
            >
              <h2 className="text-[1.12rem] leading-7 text-[#102a43]">{title}</h2>
              <span className={`ml-4 inline-flex h-8 w-8 items-center justify-center rounded-full border border-[#f6c7b4] bg-[#fff1e8] text-sm font-semibold text-[var(--brand-accent)] transition-transform duration-200 ${open ? 'rotate-180' : 'rotate-0'}`}>{open ? '-' : '+'}</span>
            </button>

            <div
              ref={contentRef}
              style={{ maxHeight: maxH, transition: 'max-height 320ms ease' }}
              className="overflow-hidden"
            >
              <div className={`mt-3 text-sm leading-7 text-[#4c5f75] transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
